<div class="sk-layout" aria-busy="true" aria-label="Loading flights">
  <aside class="sk-panel">
    <span class="sk sk--title"></span>
    @for (group of filterGroups; track $index) {
      <div class="sk-panel__group">
        <span class="sk sk--label"></span>
        @for (row of rows(group); track row) {
          <div class="sk-panel__row">
            <span class="sk sk--check"></span>
            <span class="sk sk--line"></span>
            <span class="sk sk--count"></span>
          </div>
        }
      </div>
    }
  </aside>

  <div class="sk-results">
    <div class="sk-toolbar">
      <span class="sk sk--pill"></span>
      <span class="sk sk--pill"></span>
      <span class="sk sk--pill"></span>
      <span class="sk sk--select"></span>
    </div>

    @for (card of cards; track card) {
      <div class="sk-card">
        <div class="sk-card__body">
          <div class="sk-card__legs">
            @for (leg of legSlots; track leg) {
              <div class="sk-leg">
                <div class="sk-leg__airline">
                  <span class="sk sk--logo"></span>
                  <span class="sk-leg__stack">
                    <span class="sk sk--name"></span>
                    <span class="sk sk--small"></span>
                  </span>
                </div>
                <span class="sk-leg__stack">
                  <span class="sk sk--time"></span>
                  <span class="sk sk--small"></span>
                </span>
                <span class="sk-leg__stack sk-leg__stack--center">
                  <span class="sk sk--small"></span>
                  <span class="sk sk--path"></span>
                  <span class="sk sk--chip"></span>
                </span>
                <span class="sk-leg__stack sk-leg__stack--end">
                  <span class="sk sk--time"></span>
                  <span class="sk sk--small"></span>
                </span>
              </div>
            }
          </div>
          <div class="sk-card__rail">
            <span class="sk sk--price"></span>
            <span class="sk sk--small"></span>
            <span class="sk sk--button"></span>
          </div>
        </div>
        <div class="sk-card__foot">
          <span class="sk sk--perk"></span>
          <span class="sk sk--perk"></span>
          <span class="sk sk--perk"></span>
        </div>
      </div>
    }
  </div>
</div>
